// extracted by mini-css-extract-plugin
export var container = "_6l-0";
export var fallback = "_6l-5";
export var fallbackIcon = "_6l-6";
export var hidden = "_6l-2";
export var image = "_6l-3";
export var loaded = "_6l-4";
export var placeholder = "_6l-1";